import React, { useState } from 'react'
import sea from './sea.module.css'
import { IoMdClose } from 'react-icons/io'
import { CiSearch } from 'react-icons/ci'
const Search = () => {

    const [open, setOpen] = useState(false)

    const ToggleOpen = () =>{
        setOpen(!open)
    }
  return (
    <div>
   <div className={sea.container}>
      <button onClick={ToggleOpen} className={sea.toggleButton}>
        {open ? <IoMdClose /> : <CiSearch />}
      </button>
      <input
        type="text"
        placeholder="Search..."
        className={`${sea.searchInput} ${open ? sea.open : sea.closed}`}
      />
    </div>
    </div>
  )
}

export default Search
